<template>
  <div class="main-app">
    <Swiper :swiperImgs="swiperImgs" />
    <div class="container">
      <div class="content">
        <el-row>
          <el-col :span="6" :xs="24">
            <div class="product-menu">
              <Menu
                :title="menuData.title"
                :lists="menuData.data"
                @on-click="onClickMenu"
              />
            </div>
          </el-col>
          <el-col :span="18" :xs="24">
            <div class="product-body">
              <div class="table-wrap">
                <el-table
                  :data="synopsisListCatData"
                  style="width: 100%"
                  v-loading="loading"
                >
                  <!-- <el-table-column label="" width="180">
                    <template slot-scope="scope">
                      <span class="cursor" @click="onRouter(scope.row)">
                        <img :src="scope.row.image" />
                      </span>
                    </template>
                  </el-table-column> -->
                  <el-table-column :label="$t('issueName')" width="850">
                    <template slot-scope="scope">
                      <span class="cursor" @click="onRouter(scope.row)">
                        {{ scope.row.title }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('issueDate')">
                    <template slot-scope="scope">
                      <span class="cursor" @click="onRouter(scope.row)">
                        {{ scope.row.updatetime | timeFormatDate }}
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="pagination" v-if="synopsisListCatData.length">
                <el-pagination
                  layout="prev, pager, next"
                  :page-size="synopsisListCatParams.limit"
                  :total="totalPage"
                  @current-change="onChangePage"
                >
                </el-pagination>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import LStore from "store";
import API from "@/api";
import { timeFormatDate, timeFormatYear, timeFormatMD } from "@/utils";
import Swiper from "@c/Swiper";
import Menu from "@c/Menu";

export default {
  filters: {
    timeFormatDate,
    timeFormatYear,
    timeFormatMD
  },
  data() {
    return {
      menuData: {
        title: this.$t("synopsisClassify"),
        data: []
      },
      src: require("@a/img/banner-product.png"),
      synopsisListCatData: [],
      totalPage: 0,
      synopsisListCatParams: {
        cat: this.$route.query.cat,
        page: 1,
        limit: 10
      },
      swiperImgs: [],
      loading: false
    };
  },
  components: {
    Swiper,
    Menu
  },
  created() {
    this.topingAll();
    this.productCat();
    this.synopsisCat();
    this.synopsisListCat(this.synopsisListCatParams);
  },
  // watch: {
  //   "synopsisListCatParams.cat": {
  //     handler(o, n) {
  //       console.log(o, n);
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    ...mapMutations(["SYNOPSIS_DATA","PRODUCT_DATA"]),
    productCat(params) {
            API.productCat(params).then(res => {
            if (/^(1)$/.test(res.code)) {
            this.PRODUCT_DATA(res.data);
            LStore.set("productData", res.data);
            } else {
            this.$message.error(res.msg);
            }
        });
        },
    topingAll(params) {
      API.topingAll(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(
            this,
            "swiperImgs",
            res.data.filter(v => Number(v.typelist) === 6)
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    synopsisCat(params) {
      API.synopsisCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this.menuData, "data", res.data);
          this.SYNOPSIS_DATA(res.data);
          if (this.$route.query.cat !== undefined) return;
          if (res.data[0].children !== undefined) {
            this.$set(
              this.synopsisListCatParams,
              "cat",
              res.data[0].children[0].id
            );
            this.synopsisListCat(this.synopsisListCatParams);
          } else {
            this.$set(this.synopsisListCatParams, "cat", res.data[0].id);
            this.synopsisListCat(this.synopsisListCatParams);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    synopsisListCat(params) {
      this.$set(this, "loading", true);
      API.synopsisListCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "synopsisListCatData", res.data.rows);
          this.$set(this, "totalPage", res.data.total);
          this.$set(this, "loading", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onClickMenu(v) {
      this.$set(this.synopsisListCatParams, "page", 1);
      this.$set(this, "totalPage", 0);
      this.$set(this.synopsisListCatParams, "cat", this.$route.query.cat);

      if (v.data.children === undefined) {
        if (v.data.id === this.$route.query.cat) return;
        this.$router.push({
          path: "synopsis",
          query: {
            cat: v.data.id
          }
        });
        this.synopsisListCat({ cat: v.data.id });
      }
    },
    onChangePage(v) {
      this.$set(this.synopsisListCatParams, "page", v);
      this.synopsisListCat(this.synopsisListCatParams);
    },
    onRouter(v) {
      this.$router.push({
        path: "synopsisDetails",
        query: {
          id: v.id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.product-menu {
  margin-top: 40px;
  padding-right: 80px;
}
.product-body {
  margin: 40px 0;

  .info-head {
    display: flex;
    align-items: center;
    justify-content: center;

    .product-img {
      width: 200px;
    }
  }

  .product-info {
    font-size: 14px;
    color: var(--color-black);
    line-height: 30px;

    .info-title {
      font-size: 25px;
      color: var(--color-black);
      font-weight: bold;
      margin: 20px 0;

      p {
        font-size: 18px;
        color: var(--color-light-grey);
        font-weight: normal;
        margin-top: 5px;
      }
    }
  }

  .title {
    display: flex;
    height: 100px;
    align-items: center;
    font-size: 18px;
    color: var(--color-light-black);
    font-weight: bold;

    &::before {
      display: inline-block;
      content: "";
      width: 11px;
      height: 11px;
      margin-right: 15px;
      background: var(--color-green);
    }
  }

  .info-wrap {
    padding: 0 30px;

    .icon-img {
      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .product-menu {
    padding: 0;
  }
}
</style>
